module.exports = __webpack_public_path__ + "img/support.7d066606.jpg";